import React from 'react';
import { findDOMNode } from 'react-dom';
import { TweenMax, TimelineLite } from 'gsap';
import ScrollMagic from '../../plugins/ScrollMagic';
import globals from '../../globals';

export default {

    destroy(controller) {
        controller.destroy(true);
    },

    initialise(OurValues, SubTitle) {
        this.OurValuesNode = findDOMNode(OurValues);
        this.images = [...this.OurValuesNode.querySelectorAll('.text-icon img')],
        this.headings = [...this.OurValuesNode.querySelectorAll('.text-icon h3')];

        let controller = new ScrollMagic.Controller(),
            headingTl = new TimelineLite(),
            itemsTl = new TimelineLite();

        if (SubTitle) {
            headingTl.fromTo(SubTitle, 1, globals.getSubAnimation(SubTitle), {backgroundPositionY: "0px", ease: Elastic.easeOut.config(1, 0.4)});
        }

        new ScrollMagic.Scene({
            triggerElement: '.values-trigger',
            reverse: false
        })
            .setTween(headingTl)
            .addTo(controller);

        itemsTl
            .staggerFromTo(this.images, 0.5, {y: -75, opacity: 0, scale: 0.5}, {
                y: 0,
                opacity: 1,
                scale: 1
            }, 0.1, 0)
            .staggerFromTo(this.headings, 0.5, {y: 75, opacity: 0, scale: 0.5}, {
                y: 0,
                opacity: 1,
                scale: 1
            }, 0.1, 0);

        new ScrollMagic.Scene({
            triggerElement: '.values-trigger2',
            reverse: false
        })
            .setTween(itemsTl)
            .addTo(controller);

        return controller;
    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/homepage/OurValues/animations.js